import { Trans } from "@lingui/macro";
import { Box, Button, Stack, Typography } from "@mui/material";
import axios from "axios";
import React from "react";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import styled from "styled-components";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
//import logoImg from "img/logo_Cadence.svg";
import { useWeb3React } from "@web3-react/core";
import { BACKEND_URL } from "domain/cadence-api/constants";

const RewardCard = styled(Stack)`
  display: flex;
  min-width: 500px;
  height: 90px;
  border-left: 5px solid #1fed88;
  border-right: 5px solid #1fed88;
  border-radius: 5px;
  padding: 12px;
  background-color: #131513;
  &:hover {
    cursor: pointer;
    transition: all 0.2s ease 0s;
    transform: scale(1.05);
    z-index: 10;
    background-color: rgb(9, 41, 28);
  }
`;

// const StyledRewardImage = styled.img`
//   // max-width: 100px;
//   max-height: 80px;
//   height: auto;
// `;

const ProgressBar = styled.div`
  background-color: #ddd;
  border-radius: 5px;
  height: 10px;
  overflow: hidden;
`;

const Progress = styled.div`
  background-color: #1fed88;
  height: 100%;
  transition: width 0.5s ease-in-out;
  width: ${(props) => props.width}%;
`;

const ProgressLabel = styled.div`
  font-size: 12px;
  margin-top: 5px;
  text-align: center;
`;

// const mockRewardsData = [
//   {
//     img_url: "https://media.virtuoso.com/m/cms/vcom/emailtemplate/Virt-col-h200.png",
//     title: "Virtuoso",
//     description: "You've 10Xd your money",
//   },
//   {
//     img_url: "https://cdn.motor1.com/images/mgl/BXXw8A/s1/2024-bugatti-mistral.jpg",
//     title: "Composer",
//     description: "Traded every trading pair",
//   },
//   {
//     img_url: "https://cdn.motor1.com/images/mgl/BXXw8A/s1/2024-bugatti-mistral.jpg",
//     title: "Maverick",
//     description: "50X Leverage Trade",
//   },
//   {
//     img_url: "https://cdn.motor1.com/images/mgl/BXXw8A/s1/2024-bugatti-mistral.jpg",
//     title: "Luminary",
//     description: "Created a SmartFund",
//   },
//   {
//     img_url: "https://cdn.motor1.com/images/mgl/BXXw8A/s1/2024-bugatti-mistral.jpg",
//     title: "Prodigy",
//     description: "Joining a SmartFund",
//   },
//   {
//     img_url: "https://www.shutterstock.com/image-vector/music-note-icon-flat-style-260nw-1095215549.jpg",
//     title: "Maestro",
//     description: "1M Trading Volume",
//   },
//   {
//     img_url: "https://www.shutterstock.com/image-vector/music-note-icon-flat-style-260nw-1095215549.jpg",
//     title: "Apprentice",
//     description: "100K Trading Volume",
//   },
//   {
//     img_url: "https://www.shutterstock.com/image-vector/music-note-icon-flat-style-260nw-1095215549.jpg",
//     title: "Novice",
//     description: "10K Trading Volume",
//   },
// ];

export interface Reward {
  id: string;
  title: string;
  description: string;
  img_url: string;
  walletId: string | null;
}

export interface WalletReward {
  id: string;
  walletId: string;
  rewardId: string;
  progress: number;
  minted: boolean;
}

const ProgressCircle = ({ progress }) => {
  return (
    <CircularProgressbar
      value={progress}
      text={`${progress}%`}
      styles={buildStyles({
        // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
        strokeLinecap: "butt",

        // Text size
        textSize: "24px",

        // How long animation takes to go from one percentage to another, in seconds
        pathTransitionDuration: 0.5,

        // Colors
        pathColor: `#1fed88`,
        textColor: "#1fed88",
        trailColor: "#b7b7bc",
        backgroundColor: "purple",
      })}
    />
  );
};
export default function Rewards() {
  const { account: walletAccount } = useWeb3React();
  const [allRewards, setAllRewards] = React.useState<Reward[]>([]);
  const [myRewards, setMyRewards] = React.useState<WalletReward[]>([]);
  // console.log("myRewards", myRewards);
  React.useEffect(() => {
    const init = async () => {
      // try {
      // for (let i = 0; i <= mockRewardsData.length; i++) {
      //   await axios({
      //     method: "DELETE",
      //     url: `http://localhost:3000/api/rewards/${i}`,
      //   });
      // }
      // } catch (e) {
      //   console.log("No Mock Rewards to delete");
      // }
      // GET OR CREATE WALLET
      const myWallet = await axios({
        method: "GET",
        url: `${BACKEND_URL}wallet/${walletAccount}`,
      });
      // console.log("myWallet", myWallet?.data?.wallet);
      //CREATE MOCK REWARDS
      // for (const mockReward of mockRewardsData) {
      //   console.log("mockedReward", mockReward);
      //   await axios({
      //     method: "POST",
      //     url: `${BACKEND_URL}rewards`,
      //     data: {
      //       title: mockReward.title,
      //       description: mockReward.description,
      //       img_url: mockReward.img_url,
      //       active: true,
      //     },
      //   });
      // }
      // LIST REWARDS
      const rewardsResp = await axios({
        method: "GET",
        url: `${BACKEND_URL}rewards/`,
      });
      setAllRewards(rewardsResp?.data?.rewards);
      // console.log("rewardsResp?.data?.rewards", rewardsResp?.data?.rewards);
      let myRewardsResp = await axios({
        method: "GET",
        url: `${BACKEND_URL}rewards/${walletAccount}`,
      });

      //CREATE MOCK WALLETREWARDS
      if (rewardsResp?.data?.rewards.length) {
        for (const reward of rewardsResp?.data?.rewards) {
          await axios({
            method: "POST",
            url: `${BACKEND_URL}rewards/walletreward`,
            data: {
              walletId: myWallet?.data?.wallet.id,
              rewardId: reward.id,
              progress: Math.random(),
              minted: false,
            },
          });
        }
        myRewardsResp = await axios({
          method: "GET",
          url: `${BACKEND_URL}rewards/${walletAccount}`,
        });
      }

      setMyRewards(myRewardsResp?.data?.rewards);
      // console.log("myRewardsResp?.data?.rewards", myRewardsResp?.data?.rewards);
    };
    if (walletAccount) {
      init();
    }
  }, [walletAccount]);

  const mintReward = React.useCallback(
    async (walletRewardId: string | undefined): Promise<void> => {
      if (walletRewardId) {
        await axios({
          method: "PATCH",
          url: `${BACKEND_URL}rewards/walletreward/${walletRewardId}`,
          data: {
            minted: true,
          },
        });
        // Refetch wallet rewards
        const myRewardsResp = await axios({
          method: "GET",
          url: `${BACKEND_URL}rewards/${walletAccount}`,
        });

        setMyRewards(myRewardsResp?.data?.rewards);
      } else {
        // eslint-disable-next-line no-console
        console.error("Could not find WalletReward");
      }
    },
    [walletAccount]
  );
  if (!walletAccount) {
    return (
      <div className="default-container page-layout">
        <div className="section-title-block-rewards">
          <div className="section-title-content">
            <div className="Page-title">
              <Trans>Rewards</Trans>
            </div>
            <div className="Page-description">
              <Trans>Earn rewards and gifts whenever you reach any of the goals below!</Trans>
            </div>
          </div>
        </div>
        <Stack>
          <Typography
            fontSize="48px"
            fontWeight="750"
            align="left"
            sx={{
              backgroundImage: `linear-gradient(45deg, #5514B4, #1fed88)`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Connect your wallet to see your rewards
          </Typography>
        </Stack>
      </div>
    );
  }
  return (
    <div className="default-container page-layout">
      <Stack direction="row" justifyContent="space-between" width="100%">
        <div className="section-title-block-rewards">
          <div className="section-title-content">
            <div className="Page-title">
              <Trans>Rewards</Trans>
            </div>
            <div className="Page-description">
              <Trans>Earn rewards and gifts whenever you reach any of the goals below!</Trans>
            </div>
          </div>
        </div>
        <Stack style={{ width: 70, height: 70 }}>
          <ProgressCircle progress={40} />
        </Stack>
      </Stack>
      <Stack
        sx={{
          backgroundColor: "#131513",
          // borderRadius: "4px",
          paddingY: "4px",
          paddingX: "17px",
          marginBottom: "40px",
        }}
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Stack width="100px" textAlign="center"></Stack>
        <Stack width="20%" textAlign="center">
          <Stack sx={{ fontSize: "16px" }}>Title</Stack>
        </Stack>
        <Stack width="35%" textAlign="center">
          <Stack sx={{ fontSize: "16px" }}>Description</Stack>
        </Stack>
        <Stack width="25%" textAlign="center">
          <Stack sx={{ fontSize: "16px" }}>Progress</Stack>
        </Stack>
        <Stack width="10%" textAlign="center"></Stack>
      </Stack>
      <Stack spacing={4}>
        {allRewards.map((reward) => {
          const currentReward = myRewards.find((myReward) => myReward.rewardId === reward.id);
          const ableToMint = currentReward?.minted === false;
          return (
            <RewardCard
              direction="row"
              justifyContent="center"
              alignItems="center"
              width="100%"
              onClick={(): void => {
                if (ableToMint) {
                  mintReward(currentReward?.id);
                }
              }}
            >
              <Stack width="10%" alignItems={"center"}>
                <MusicNoteIcon style={{ width: "40px", height: "40px" }} />

                {/* <StyledRewardImage src={reward.img_url} alt={reward.title} /> */}
              </Stack>
              <Stack width="20%" textAlign="center">
                <Stack sx={{ fontSize: "20px" }}>{reward.title}</Stack>
              </Stack>
              <Stack width="35%" textAlign="center">
                <Stack sx={{ fontSize: "16px" }}>{reward.description}</Stack>
              </Stack>
              <Stack width="25%" textAlign="center">
                <ProgressBar>
                  <Progress width={currentReward?.progress ? Math.round(currentReward.progress * 100) : 0} />
                </ProgressBar>
                <ProgressLabel>{currentReward?.progress ? Math.round(currentReward.progress * 100) : 0}%</ProgressLabel>
              </Stack>
              <Stack width="10%" textAlign="center">
                {true && (
                  <Box>
                    <Button sx={{ color: "#1fed88", minWidth: "fit-content" }}>Mint</Button>
                  </Box>
                )}
              </Stack>
            </RewardCard>
          );
        })}
      </Stack>
    </div>
  );
}
